import { useState } from "react";
import { animeList, categoryMeta, type Anime } from "@/mocks/animeData";

const catOrder: Anime["category"][] = ["healing", "slice", "cute", "warm"];

function Categories() {
  const [active, setActive] = useState<Anime["category"]>("healing");
  const items = animeList.filter((a) => a.category === active);
  const meta = categoryMeta[active];

  return (
    <section
      id="categories"
      className="w-full bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="text-xs font-semibold tracking-widest text-accent-600 uppercase">
            Categories
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
            按情绪挑番，按片单分类
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm md:text-base text-foreground-700">
            不知道怎么挑？先选一种想要的心情，我们把你需要的治愈番都整理好。
          </p>
        </div>

        <div className="mx-auto mb-8 md:mb-10 flex max-w-3xl flex-wrap justify-center gap-2 rounded-full bg-background-50 border border-background-200/70 p-1.5">
          {catOrder.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`inline-flex whitespace-nowrap items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-primary-100/70"
              }`}
            >
              <i className={categoryMeta[c].icon}></i>
              {categoryMeta[c].label}
            </button>
          ))}
        </div>

        <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className={meta.icon}></i>
            </span>
            <h3 className="font-heading text-xl text-foreground-950">
              {meta.label} · {items.length} 部精选
            </h3>
          </div>
          <p className="text-sm text-foreground-700">{meta.desc}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((a) => (
            <article
              key={a.id}
              className="overflow-hidden rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 transition-colors"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title} ${meta.label}推荐`}
                  className="h-full w-full object-cover"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {meta.label}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h4 className="font-heading text-lg text-foreground-950 whitespace-nowrap">
                    {a.title}
                  </h4>
                  <span className="text-xs font-semibold text-accent-700">
                    {a.score} 分
                  </span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-700">
                  {a.desc}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {a.mood.map((m) => (
                    <span
                      key={m}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                    >
                      {m}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;